module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAAU9JREFUWEftl7FOwzAQhv+/qgQP0C6QB+ABQGLs0AGJpQMDYyeakYHX6EzKxNaxEwMjc/sYjUAqD9ABOORKQWkV6nOVWInkrLbPn7+7OBeiZg9rxoMAZMtIMKQ2dHon1ySeQXRsi8ocF8EnBMP0iS8m7l/KolhWgF+Y7GAGKp2wuwskZZ7cNdYy4UZO3lAAyltsnqGM2LUWolj+T71g/QPcAohbxJWTodKBBOtvYvCe8BVDOT45wiwP5TdleRijpSft6AxTADeZJX9AChgD5QdICeMHyAFGBaQt6sK3yhGmciABHtKE403BFhRw0VVSaQ19Eb2PR75pYVSGXC/ErfmCezGdA9EncKmJVakhDcDunABks9YAQyNZ+e6n97awtWvybTn2Nd7cH8VoJHMQ5weZEiyWE15o1qoN7W1NFTtpP9ZqIMWepUwJQDaNtTP0C9fLxSX4kCQ1AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/student.png
// module id = hjns
// module chunks = 1